import React from 'react';
import { Tab } from '@mui/material';
import TicketDetails from '../manage-details/tickets/TicketDetails';
import '../../../../../styles/components/CreateEvent.css';

export default function ManageTicket() {
    return (
        <React.Fragment>
            <section id="create-event-tickets-section">
                <div className="event-creation-stepper">
                    <Tab label="Tickets" />
                </div>
                <div className="event-creation-tabs-content">
                    <TicketDetails />
                </div>
            </section>
        </React.Fragment>
    );
}

// const ticketTabStyle = {
//     '&.Mui-disabled': {
//         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
//         backgroundColor: 'rgba(0, 0, 0, 0.2)',
//         color: 'rgba(245, 245, 245, 0.6)'
//     },
//     borderRadius: '0.5rem',
//     textTransform: 'capitalize',
//     fontFamily: 'Nunito, sans-serif',
//     fontSize: '1rem',
//     padding: '0.5rem 1rem',
//     maxWidth: '236px',
//     border: '1px solid #26c1e8',
//     backgroundColor: '#3e414d',
//     color: '#26c1e8'
// };
